var scope_0 = require('/Users/jacob/Git/Rallista-Web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6bc1c78827f15282d84cfeab0112ab51.js').default;
var scope_1 = require('/Users/jacob/Git/Rallista-Web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    